import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-sepa-check',
  templateUrl: './sepa-check.component.html',
  styleUrls: ['./sepa-check.component.scss'],
  imports: [CommonModule, MatIconModule],
})
export class SepaCheckComponent {
  @Input() white: boolean = false;

  constructor() {}
}
